// extracted by mini-css-extract-plugin
export default {"new-question-button-wrap":"NewQuestionButton_new-question-button-wrap__ia+ZP"};